import { RestSlice } from '../../../../../redux/rest.slice';
import { localizationService, Resource } from 'src/services';
import { Lookup } from '@rcp/types/src';

export const settingLookupsSiteTypeSlice = new RestSlice<Lookup>(
	localizationService.getLocalizedString('cccSettings.lookupSiteTypes'),
	Resource.SettingLookup + '/SiteTypes'
);
export default settingLookupsSiteTypeSlice.rests.reducer;
